import { ArrowForwardIosRounded } from '@mui/icons-material';
import { Box, Button, List, ListItemText, Stack } from '@mui/material';
import styles from 'features/DefaultHelp.module.css';
import { memo, useState } from 'react';

const InstructionsSection = () => {
    const instructions = [
        {
            key: 'create',
            title: 'Create a New Ticket',
        },
        {
            key: 'track',
            title: 'Track Existing Tickets',
        },
        {
            key: 'notify',
            title: 'Stay Notified',
        },
    ];

    const [selectedInstructions, setSelectedInstructions] = useState(instructions[0].key);

    const CreateInstruction = memo(
        () => (
            <>
                <p className={styles['instruction-header']}>Asset Search</p>
                <List className={styles['ordered-list']}>
                    <ListItemText className={styles['list-item']}>
                        <span>Click the “+ Add new” button.</span>
                    </ListItemText>
                    <ListItemText className={styles['list-item']}>
                        <span>Fill in the required fields: subject, description, and any supporting details.</span>
                    </ListItemText>
                    <ListItemText className={styles['list-item']}>
                        <span>Submit the ticket to notify the CS team. </span>
                    </ListItemText>
                </List>
            </>
        ),
        []
    );
    CreateInstruction.displayName = 'AssetSearchInstructions';

    const TrackTicketInstruction = memo(
        () => (
            <>
                <p className={styles['instruction-header']}>Switch Inventory View</p>
                <List className={styles['ordered-list']}>
                    <ListItemText className={styles['list-item']}>
                        <span>Use the search bar to locate a specific ticket.</span>
                    </ListItemText>
                    <ListItemText className={styles['list-item']}>
                        <span>Use filters to view tickets by their current status. </span>
                    </ListItemText>
                    <ListItemText className={styles['list-item']}>
                        <span>Click Refresh to ensure you&apos;re viewing the latest ticket updates. </span>
                    </ListItemText>
                </List>
            </>
        ),
        []
    );
    TrackTicketInstruction.displayName = 'AssetSwitchViewInstructions';

    const StayNotifiedInstruction = memo(
        () => (
            <>
                <p className={styles['instruction-header']}>View Asset in Inventory</p>
                <List className={styles['ordered-list']}>
                    <ListItemText className={styles['list-item']}>
                        <span>You will receive an email notification every time your ticket receives a response from the CS team.</span>
                    </ListItemText>
                    <ListItemText className={styles['list-item']}>
                        <span>Make sure to check your email regularly for updates and reply promptly if further information is needed.</span>
                    </ListItemText>
                </List>
            </>
        ),
        []
    );
    StayNotifiedInstruction.displayName = 'ViewAssetInstructions';

    const getInstructionsComponent = (key) => {
        switch (key) {
            case 'create':
                return <CreateInstruction />;
            case 'track':
                return <TrackTicketInstruction />;
            case 'notify':
                return <StayNotifiedInstruction />;
        }
    };
    return (
        <>
            <h4>INSTRUCTIONS</h4>
            <Box display="flex" flexDirection="row" boxSizing="border-box" height="24rem" width="100%">
                <Box className={styles['instruction-title-container']}>
                    <Stack spacing={2}>
                        {instructions.map((instruction) => (
                            <Button
                                key={instruction.key}
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                    setSelectedInstructions(instruction.key);
                                }}
                                className={`${styles['instruction-button']}
                          ${selectedInstructions === instruction.key ? styles['instruction-button--selected'] : ''}`}
                                disableRipple
                            >
                                {instruction.title}
                                <ArrowForwardIosRounded className={styles['arrow-right']} />
                            </Button>
                        ))}
                    </Stack>
                </Box>
                <Box className={styles['instruction-content-container']}>{getInstructionsComponent(selectedInstructions)}</Box>
            </Box>
        </>
    );
};

export default InstructionsSection;
